export default "__VITE_ASSET__1qF7BWRv__"